import React, { useState, useRef } from 'react';
import { database } from '../../firebase'; // Importing Firebase database
import { ref, push } from 'firebase/database'; // Firebase Realtime Database methods
import './ContactUs.css'; // Import CSS styles

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [sendingStatus, setSendingStatus] = useState('');
  const submitting = useRef(false);
  const [busy, setBusy] = useState(false);
  const [isSent, setIsSent] = useState(false); // Track if message was sent

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting.current) return;
    const message = Object.fromEntries(Object.entries(formData).map(([key, value]) => [key, value.trim()]));
    if (Object.values(message).some(value => !value)) {
      setIsSent(false);
      setSendingStatus('Please fill in every field.');
      return;
    }
    submitting.current = true;
    setBusy(true);
    setIsSent(false);
    setSendingStatus('Sending…');

    // Reference to the contact_messages node in Realtime Database
    const messagesRef = ref(database, 'contact_messages'); // Reference to the base node

    // Store form data in Realtime Database using push
    try {
      await push(messagesRef, {
        name: message.name,
        email: message.email,
        message: message.message,
        timestamp: new Date().toISOString(), // Store original timestamp without modification
      });

      setSendingStatus('Message sent successfully!');
      setIsSent(true); // Set message sent status to true
      setFormData({ name: '', email: '', message: '' }); // Reset form fields
    } catch (error) {
      console.error("Error saving message:", error);
      setSendingStatus('Error sending message. Please try again.');
      setIsSent(false); // Reset message sent status
    } finally {
      submitting.current = false;
      setBusy(false);
    }
  };

  return (
    <div className='contact-us-container'>
      <h1>Contact Me</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="contact-name">Name:</label>
          <input type="text" name="name" id="contact-name" disabled={busy} value={formData.name} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="contact-email">Email:</label>
          <input type="email" name="email" id="contact-email" disabled={busy} value={formData.email} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="contact-message">Message:</label>
          <textarea name="message" id="contact-message" disabled={busy} value={formData.message} onChange={handleChange} required></textarea>
        </div>
        <button type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send Message'}</button>
      </form>
      {sendingStatus && (
        <p role="status" className={isSent ? 'swoosh' : ''}>{sendingStatus}</p>
      )} {/* Display sending status with swoosh effect */}
    </div>
  );
};

export default ContactUs;